import React from "react";
import { Link } from "react-router-dom";

const PayHeader = ({ logo, theme }) => {
  // Determine the default logo based on theme
  const defaultLogo = theme === "DARK"
    ? "/images/logo/logo-White.svg"
    : "/images/logo/logo-black.svg";

  return (
    <>
      <header className="pay-header">
        <div className="container">
          <div className="header-inner">
            <div className="logo">
              <Link to="/">
                <a>
                  <img
                    src={logo ? logo : defaultLogo}
                    alt="logo"
                    style={{ maxWidth: "100%", maxHeight: "80px", objectFit: "contain" }}
                  />
                </a>
              </Link>
            </div>
          </div>
        </div>
      </header>
    </>
  );
};

export default PayHeader;
